module.exports = __webpack_public_path__ + "static/media/9.dc8fd60b.png";